import {useState} from 'react';
import {XIcon} from 'lucide-react';
import {Switch} from 'components/common/Switch.component';
import {ICON_SIZE} from 'components/common/constants';
import {hasDismissedBetaNudge, markBetaNudgeDismissed} from './betaVersion.function';
import type {Translate} from 'types/myTasks';

interface BetaSwitchProps {
    isChecked: boolean;
    onChange: () => void;
    translate: Translate;
}

/**
 * "Try the Beta version" switch, shown at the bottom left of the list, in its footer row,
 * with a nudge above it for everyone who has not turned the beta on yet.
 */
const BetaSwitch = ({isChecked, onChange, translate}: BetaSwitchProps) => {

    const [nudgeDismissed, setNudgeDismissed] = useState(hasDismissedBetaNudge);

    const dismissNudge = () => {
        setNudgeDismissed(true);
        markBetaNudgeDismissed();
    };

    const showNudge = !isChecked && !nudgeDismissed;

    return (
        <div className={`my-tasks-beta-switch${showNudge ? ' my-tasks-beta-switch--nudged' : ''}`}
             data-cy="myTasks.betaSwitch">
            {showNudge &&
                <div className="my-tasks-beta-nudge" role="status" data-cy="myTasks.betaNudge">
                    <span>{translate('myTasks.overview.nudge')}</span>
                    <button type="button"
                            className="my-tasks-beta-nudge__close"
                            aria-label={translate('myTasks.overview.nudgeDismiss')}
                            onClick={dismissNudge}>
                        <XIcon size={ICON_SIZE.SMALL} aria-hidden="true"/>
                    </button>
                </div>
            }
            <Switch
                label={isChecked ? translate('myTasks.overview.beta') : translate('myTasks.overview.old')}
                isChecked={isChecked}
                isDisabled={false}
                onChange={onChange}
            />
        </div>
    );
};

export default BetaSwitch;
